/** @typedef {string} CustomerGroupImportCustomersType */
export const CUSTOMER_GROUP_IMPORT_CUSTOMERS_TYPE_IMPORT = 'IMPORT';
export const CUSTOMER_GROUP_IMPORT_CUSTOMERS_TYPE_CUSTOMER_SEARCH = 'CUSTOMER_SEARCH';
export const CUSTOMER_GROUP_IMPORT_CUSTOMERS_TYPE_CUSTOMER_SEGMENT = 'CUSTOMER_SEGMENT';
export const CUSTOMER_GROUP_IMPORT_CUSTOMERS_TYPE_OPEN_API = 'OPEN_API';
/** @enum {CustomerGroupImportCustomersType} */
export const CUSTOMER_GROUP_IMPORT_CUSTOMERS_TYPE = {
	IMPORT: CUSTOMER_GROUP_IMPORT_CUSTOMERS_TYPE_IMPORT,
	CUSTOMER_SEARCH: CUSTOMER_GROUP_IMPORT_CUSTOMERS_TYPE_CUSTOMER_SEARCH,
	CUSTOMER_SEGMENT: CUSTOMER_GROUP_IMPORT_CUSTOMERS_TYPE_CUSTOMER_SEGMENT,
	OPEN_API: CUSTOMER_GROUP_IMPORT_CUSTOMERS_TYPE_OPEN_API,
};
/** @type {CustomerGroupImportCustomersType[]} */
export const CUSTOMER_GROUP_IMPORT_CUSTOMERS_TYPES = [
	CUSTOMER_GROUP_IMPORT_CUSTOMERS_TYPE_IMPORT,
	CUSTOMER_GROUP_IMPORT_CUSTOMERS_TYPE_CUSTOMER_SEARCH,
	CUSTOMER_GROUP_IMPORT_CUSTOMERS_TYPE_CUSTOMER_SEGMENT,
	CUSTOMER_GROUP_IMPORT_CUSTOMERS_TYPE_OPEN_API,
];